import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '../services/language/language.service';

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  const lang = inject(LanguageService).getCurrentLang();

  const newParams = req.params.set('lang', lang);

  return next(req.clone({ params: newParams }));
};
